import React, { useState } from 'react';
import { gradient } from '../controls/Gradient';
import StyleButton from '../controls/StyleButton';
import axios from 'axios';
import Swal from 'sweetalert2';
import FormInput from '../controls/FormInput';

interface objectData {
  name?: string;
  email?: string;
  phone?: string;
  about?: string;
}

const checkValidEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
interface FormProps {
  agent_email: string;
}
function Form({ agent_email }: FormProps) {
  const [data, setData] = useState<objectData>({
    name: '',
    email: '',
    phone: '',
    about: ''
  });
  const [error, setError] = useState<objectData>({ name: '', email: '', phone: '' });
  async function submitForm() {
    if (
      !data.name ||
      !data.email ||
      !data.phone ||
      !checkValidEmail.test(data.email) ||
      !data.about
    ) {
      return setError({
        name: !data.name ? 'Name is required' : '',
        email: !data.email
          ? 'Email is required'
          : !checkValidEmail.test(data.email)
          ? 'Enter valid email'
          : '',
        phone: !data.phone ? 'Phone is required' : '',
        about: !data.about ? 'About is required' : ''
      });
    } else {
      const num = await checkPhoneIsCanadianValidOrNot();

      if (num) {
        setError({ name: '', email: '', phone: '' });
        try {
          const res = await axios({
            method: 'post',
            url: 'https://nu2morrow.com/crm/apis/Joinusnuborrow/Join_and_contact_us',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: {
              first_name: data.name,
              email: data.email,
              phone: data.phone,
              about_message: data.about,
              to_agent: agent_email,
              lead_source: 'teamsAgent'
            }
          });
          if (res?.status === 200) {
            setData({
              name: '',
              email: '',
              phone: '',
              about: ''
            });
            return Swal.fire({
              icon: 'success',
              title: 'Thank You',
              text: ''
            });
          }
        } catch (err) {
          return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Error'
          });
        }
      } else {
        setError({ phone: 'Enter Valid Number' });
      }
    }
  }
  const checkPhoneIsCanadianValidOrNot = async () => {
    const formData = new FormData();
    formData.append('contact_no', data.phone ? data.phone : '');
    try {
      const { data } = await axios({
        method: 'post',
        url: 'https://nu2morrow.com/crm/apis/SecUser/contactvalidator',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (data?.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };

  function formatPhoneNumber(phoneNumber: any) {
    const cleanNum = phoneNumber.toString().replace(/\D/g, '');
    const match = cleanNum.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);

    if ((match && match[2]) === '') {
      return match[1];
    }

    if ((match && match[3]) === '') {
      return `(${match[1]}) ${match[2]}`;
    }

    if (match) {
      return `(${match[1]}) ${match[2] ? `${match[2]}-` : ''} ${match[3]}`;
    }
    return cleanNum;
  }

  return (
    <div className={`${gradient} mx-auto rounded-lg p-5 lg:w-[596px]`}>
      <div className="flex flex-col flex-wrap items-center justify-center gap-2 md:flex-row ">
        <div className="md:flex md:gap-3">
          <FormInput
            label="Your Full Name"
            placeholder="Name"
            value={data.name}
            error={error.name}
            onChange={(e: any) => setData({ ...data, name: e.target.value })}
            className="w-72 md:w-80 lg:w-[250px]"
          />
          <FormInput
            label="Your Email"
            placeholder="example@gmail.com"
            value={data.email}
            error={error.email}
            onChange={(e: any) => setData({ ...data, email: e.target.value })}
            className="w-72 md:w-80 lg:w-[250px]"
          />
        </div>
        <FormInput
          label="Your Phone"
          placeholder="000-000-000"
          value={data.phone}
          error={error.phone}
          onChange={(e: any) => {
            if (e.target.value?.length > 15) {
              return;
            }
            setData({ ...data, phone: formatPhoneNumber(e.target.value) });
          }}
          className="w-72 md:w-[652px] lg:w-[516px]"
        />

        <div className="w-72 md:w-[652px] lg:w-[516px]">
          <div className={`px-1 py-2 text-base font-semibold`}>Message</div>

          <textarea
            maxLength={200}
            value={data.about}
            className="h-32 w-full rounded-md border-2 px-3 py-2 text-base font-normal text-brand  focus:outline-brand lg:px-4  lg:py-3"
            placeholder="Your message"
            onChange={(e: any) => setData({ ...data, about: e.target.value })}
          />
          <div className="px-1 py-2 text-xs3 font-medium text-red-700 lg:text-xs">
            {error.about}
          </div>
        </div>
        <StyleButton text="Contact" onClick={submitForm} />
      </div>
    </div>
  );
}

export default Form;
